module.exports = __webpack_public_path__ + "img/SPQRvsCF.cdeca438.png";